import {useState} from 'react'
import "./Convertisseur.css"

export function Convertisseur () {
 	document.title = 'Convertisseur'

	const grandeurs = ['longueur', 'aire', 'volume', 'température']
	const unites = {
		longueur: ['km', 'hm', 'dam', 'm', 'dm', 'cm', 'mm', '', '', 'µm', '', '', 'nm'],
		aire: ['km²', 'hm²', 'dam²', 'm²', 'dm²', 'cm²', 'mm²'],
		surface: ['ha', 'a', 'ca'],
		volume: ['m³', 'dm³', 'cm³', 'mm³'],
		contenance: ['L', 'dL', 'cL', 'mL'],
		température: ['°C', '°F'],
	}
	
	const [choix, setChoix] = useState({
		grandeur: 'longueur',
		unites: ['km', 'hm', 'dam', 'm', 'dm', 'cm', 'mm', '', '', 'um', '', '', 'nm'],
		start: 'm',
		end: 'cm',
		valeur:'1',
	})

	const numberFormat = (val) => {
		//console.log(val)
		if(val >= 1) {return (val.toLocaleString())}
		let ent = Math.floor(val)
		let decimal = (val+'').includes('.') ? (val+'').split('.')[1] : val
		if(decimal.length > 6){decimal = decimal.slice(0,6)+' '+decimal.slice(6)}
		if(decimal.length > 3){decimal = decimal.slice(0,3)+' '+decimal.slice(3)}
		return ent+','+decimal
		return (val+'').replace('.', ',').replace('000', '000 ')
	}

	const convertir = (val) => {
		let n = choix.unites.indexOf(choix.end)-choix.unites.indexOf(choix.start)
		switch (choix.grandeur){
			case 'longueur':
				if(n < 0) {return numberFormat(val/10**-n)}
				return numberFormat(val*10**n)
				break
			case 'aire':
				n = 2*n
				if(choix.start.includes('²') && !choix.end.includes('²')){
					n = 2 - 2 * unites.aire.indexOf(choix.start) + 2 * unites.surface.indexOf(choix.end)
				}
				if(!choix.start.includes('²') && choix.end.includes('²')){
					n = -2 - 2 * unites.surface.indexOf(choix.start) + 2 * unites.aire.indexOf(choix.end)
				}
				if(n < 0) {return numberFormat(val/10**-n)}
				return numberFormat(val*10**n)
				break
			case 'volume':
				n = 3*n
				if(choix.start.includes('³') && choix.end.includes('L')){
					n = 3 - 3 * unites.volume.indexOf(choix.start)+unites.contenance.indexOf(choix.end)
				}
				if(choix.start.includes('L') && choix.end.includes('³')){
					n = -3 + 3 * unites.volume.indexOf(choix.end)-unites.contenance.indexOf(choix.start)
				}
				if(choix.start.includes('L') && choix.end.includes('L')){
					n = n/3
				}
				if(n < 0) {return numberFormat(val/10**-n)}
				return numberFormat(val*10**n)
				break
			case 'température':
				if(choix.start === '°C' && choix.end === '°F'){
					return Math.floor((choix.valeur * 1.8+32)*10)/10
				}
				if(choix.start === '°F' && choix.end === '°C'){
					return Math.floor(((choix.valeur-32)/1.8)*10)/10
				}
				return val
				break
		}
	}

	const handleClick = (e) => {
		//console.log(e.target.attributes.name.value)
		setChoix({...choix, [e.target.attributes.name.value]:e.target.innerText.trim()})
	}
	const handleChange = (e) => {
		setChoix({...choix, valeur:e.target.value.replace(',', '.')})
	}

	//console.log(choix.unites.indexOf(choix.end)-choix.unites.indexOf(choix.start))
	//console.log(choix)
  	return (
  	<>
  	<h1>Convertisseur</h1>
  	<div className="choix_grandeur">
  		{grandeurs.map((grandeur, k) => <span key={k} className={'btn_grandeur '+(choix.grandeur===grandeur ? 'active' : '')} onClick={()=>setChoix({...choix, grandeur, unites:grandeur === 'volume' ? unites[grandeur].concat(unites['contenance']) : (grandeur === 'aire' ? unites[grandeur].concat(unites['surface']) : unites[grandeur]), start:unites[grandeur][0], end:unites[grandeur][0]})}>{grandeur[0].toUpperCase() + grandeur.slice(1)}</span>)}
  	</div>
    <div className="content">
    	<h1>Conversion {(choix.grandeur === 'aire' ? 'd\'' : 'de ') +choix.grandeur}</h1>
    	<div>
    		Unité de départ : {choix.unites.map((unite, k) => unite && <span key={k} className={'btn_param '+(choix.start===unite ? 'active' : '')} name="start" onClick={handleClick}>{unite} </span>)}
    		<br/><br/>
    	</div>
    	<div>
    		A convertir en : {choix.unites.map((unite, k) =>  unite && <span key={k} className={'btn_param '+(choix.end===unite ? 'active' : '')} name="end" onClick={handleClick}>{unite} </span>)}
    		<br/><br/><br/><br/>
    		<span className="convert_result">
    			<input type="text" size={choix.valeur.length+2} value={choix.valeur} onChange={handleChange} /> {choix.start} = {convertir(choix.valeur)}  {choix.end}
    		</span>
    		<br/><br/>
    	</div>
    </div>
    </>
  );
}